declare var customSaveSystemSettingsRow: any;
declare var customSetupSystemSettingsRow: any;

namespace Ir.Components.SystemSettingsService {
    interface IViewModel {
        dataGridOptions: DevExpress.ui.dxDataGrid.Properties;
        
        onSave: () => void;
        onCancel: () => void;
    }
    interface IParams {
        getComponent: (component: IViewModel) => void;
        updateSaveCancelButton: (disabled: boolean) => void;
    }

    interface ResultSystemSettings {
        dataSource: Array<any>;
        groups: Array<any>;
    }

    export function getViewModel(this: IViewModel, params: IParams) {
        let systemSettingsRowChanged = [];
        let self = this;
        let result = load(self, params);
        let hasChanges = false;

        let store = new DevExpress.data.CustomStore({
            key: "id",
            load: function (loadOptions) {
                return result.dataSource;
            },
            update: function (key, values: any) {
                let d = $.Deferred();
                let row = result.dataSource.find(function (x) { return x.id === key; });

                let rowChanged = systemSettingsRowChanged.find(function (x) { return x.id === key; });
                if (rowChanged) {
                    if (rowChanged.oldValue == values.value) {
                        const index = systemSettingsRowChanged.indexOf(rowChanged);
                        if (index > -1) {
                            systemSettingsRowChanged.splice(index, 1);
                        }

                        hasChanges = systemSettingsRowChanged.length !== 0;
                        params.updateSaveCancelButton(systemSettingsRowChanged.length === 0);
                    }
                    else {
                        rowChanged.value = values.value;
                    }
                }
                else {
                    systemSettingsRowChanged.push({
                        id: key,
                        value: values.value,
                        oldValue: row.value
                    });

                    hasChanges = true;
                    params.updateSaveCancelButton(false);
                }

                Object.assign(row, values);

                d.resolve();
                return d.promise();
            }
        });

        self.dataGridOptions = {
            editing: {
                mode: 'cell',
                allowUpdating: true
            },
            loadPanel: {
                enabled: false
            },
            showBorders: true,
            showColumnLines: false,
            showRowLines: true,
            showColumnHeaders: false,
            grouping: {
                autoExpandAll: true,
            },
            paging: {
                enabled: false
            },
            groupPanel: {
                visible: true,
            },
            searchPanel: {
                visible: true,
                highlightSearchText: true,
            },
            toolbar: {
                items: [
                    {
                        location: 'after',
                        name: "searchPanel",
                    }
                ],
            },
            keyExpr: 'id',
            dataSource: store,
            columns: [
                { dataField: "id", visible: false },
                { dataField: "order", visible: false, sortOrder: 'asc' },
                {
                    dataField: "name",
                    allowEditing: false,
                    width: 240,
                    cssClass: "dx-editor-cell",
                },
                {
                    dataField: "value",
                    showEditorAlways: true,
                    alignment: "left",
                    width: 230,
                    validationRules: [{
                        type: "custom",
                        validationCallback: function (v) {
                            if (!v.data.required) {
                                return true;
                            }

                            if (v.data.type === SystemSettingRowTypeEnum.Boolean && (v.value as any) === false) {
                                return true;
                            }

                            if (v.data.type === SystemSettingRowTypeEnum.Numeric && v.value === 0) {
                                return true;
                            }

                            if (!v.value || v.value === "") {
                                return false;
                            }

                            return true;
                        },
                        message: "Value is required"
                    }]
                },
                {
                    type: 'buttons',
                    alignment: 'left',
                    cssClass: "dx-editor-cell",
                    width: 48,
                    buttons: [
                        {
                            icon: 'revert',
                            onClick(options) {
                                let data = options.row.data;
                                let index = options.component.getRowIndexByKey(data.id);
                                options.component.cellValue(index, "value", data.defaultValue);
                                options.component.saveEditData();
                            },
                            template: function (element, data) {
                                let div = $("<div>").addClass("dx-icon-revert").css("display", "inline-block");

                                let defaultValue = data.data.defaultValue;
                                if (data.data.editorType === SystemSettingEditorTypeEnum.Dropdown) {
                                    defaultValue = data.data.optionList.find(function (x) { return x.id == defaultValue; }).text;
                                }
                                else if (data.data.editorType === SystemSettingEditorTypeEnum.ColorPicker) {
                                    defaultValue = `<div class='color-example' style='background-color:${defaultValue}'></div> ${defaultValue}`;
                                }

                                if (data.data.type === SystemSettingRowTypeEnum.JSON) {
                                    defaultValue = "";
                                }

                                div.append(
                                    $("<div>").html(`Restore default value.<br /><b>${defaultValue}</b>`).dxTooltip({
                                        target: div,
                                        showEvent: 'mouseenter',
                                        hideEvent: 'mouseleave'
                                    })
                                );
                                return div;
                            },
                        },
                        {
                            icon: 'warning',
                            visible: function (data) {
                                return data.row.data.obsolete;
                            },
                            template: function (element, data) {
                                let warning = $("<div>").addClass("dx-icon-warning").css("display", "inline-block");
                                warning.append(warning.append(
                                    $("<div>").html(data.data.obsoleteText).dxTooltip({
                                        target: warning,
                                        showEvent: 'mouseenter',
                                        hideEvent: 'mouseleave'
                                    })
                                ));
                                return warning;
                            },
                        },
                    ],
                },
                {
                    dataField: "description",
                    allowEditing: false,
                    encodeHtml: false,
                },
                {
                    dataField: 'groupId',
                    groupIndex: 0,
                    groupCellTemplate: function (element, options) {
                        let group = result.groups.find(function (x) { return x.groupId === options.value });
                        element.text(group.groupName);
                    },
                    sortingMethod: function (value1, value2) {
                        let group1 = result.groups.find(function (x) { return x.groupId === value1; });
                        let group2 = result.groups.find(function (x) { return x.groupId === value2; });

                        if (group1.groupOrder < group2.groupOrder) return -1;
                        if (group1.groupOrder > group2.groupOrder) return 1;

                        return 0;
                    }
                }
            ],
            onEditorPreparing: function (e) {
                onEditorPreparing(e);
            }
        };

        if (params.getComponent) {
            params.getComponent(this);
        }

        this.onSave = function() {
            let submitObj = {
                __RequestVerificationToken: $('input[name="__RequestVerificationToken"]').val(),
                rows: systemSettingsRowChanged,
            };

            irGlobal.updateFromServer(null,
                urlConfigs.systemSettings + "/SaveSystemSettings",
                submitObj,
                function () {
                    systemSettingsRowChanged = [];
                    hasChanges = false;
                    params.updateSaveCancelButton(true);
                    DevExpress.ui.notify("System Settings saved")
                },
                function (textStatus, errorThrown, errorItem: IError) {
                    errorItem.userMessage = "Failed to save system settings";
                    irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, errorThrown);
                });
        };
        this.onCancel = function () {
            hasChanges = false;
            location.reload();
        };

        window.addEventListener("beforeunload", function (e) {
            if (hasChanges) {
                const message = "You have unsaved changes. Are you sure you want to exit?";
                e.preventDefault();
                e.returnValue = message;
                return message;
            }
        });
    }

    function load(self: IViewModel, params: IParams): ResultSystemSettings {
        let result = { dataSource: [], groups: [] } as ResultSystemSettings;

        let o = {
            url: `${urlConfigs.systemSettings}/Get`,
            data: {  },
            dataType: "json",
            async: false
        } as RequestServerParams;
        o.successFunction = function (data: any, e) {
            result = data;
        };
        o.failureFunction = function (textStatus, errorThrown, errorItem: IError) {
            errorItem.userMessage = "Failed to get relationships";
            irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, errorThrown);
        };

        irGlobal.requestServer(o);

        return result;
    }

    function onEditorPreparing(e) {

        if (!e?.row)
            return;

        switch (e.row.data.editorType) {
            case SystemSettingEditorTypeEnum.Dropdown:
                e.editorName = "dxSelectBox";
                e.editorOptions.dataSource = e.row.data.optionList;
                e.editorOptions.valueExpr = "id";
                e.editorOptions.displayExpr = "text";
                e.editorOptions.searchEnabled = true;
                break;
            case SystemSettingEditorTypeEnum.Numeric:
                e.editorName = "dxNumberBox";
                e.editorOptions.min = 0;
                e.editorOptions.max = 1000000;
                e.editorOptions.step = 1;
                e.editorOptions.showSpinButtons = true;
                e.editorOptions.format = "0#";
                break;
            case SystemSettingEditorTypeEnum.Textbox:
                e.editorName = "dxTextBox";
                e.editorOptions.maxLength = e.row.data.size;
                break;
            case SystemSettingEditorTypeEnum.Switch:
                e.editorName = "dxSwitch";
                e.editorOptions.value = e.value;
                break;
            case SystemSettingEditorTypeEnum.ColorPicker:
                let input = $(`<input type="text" />`);
                input.appendTo(e.editorElement);
                (input as any).spectrum({
                    type: "color",
                    color: e.value,
                    hideAfterPaletteSelect: "true",
                    showInitial: true,
                    showAlpha: false,
                    allowEmpty: true,
                    showInput: true,
                    appendTo: "body",
                    change: function (color) {
                        if (color)
                            e.setValue(color.toHexString());
                        else
                            e.setValue("");
                    }
                });
                $(".sp-replacer.sp-light", e.editorElement).css("width", "50px").css("height", "25px");
                $(".sp-dd", e.editorElement).css("line-height", "25px");
                e.cancel = true;
                break;
            case SystemSettingEditorTypeEnum.Date:
                e.editorName = "dxDateBox";
                e.editorOptions.type = 'date';
                e.editorOptions.displayFormat = 'd MMMM yyyy';
                break;
            case SystemSettingEditorTypeEnum.Custom:
                e.editorName = "dxButton";
                e.editorOptions.text = "...";
                e.editorOptions.height = "22px";
                e.editorOptions.onClick = function () {
                    let oldValue = e.value;

                    let o = {
                        url: urlConfigs.systemSettings + "/GetSystemSettingsRowView",
                        data: {
                            id: this.id,
                            value: typeof e.value === "object" ? JSON.stringify(e.value) : e.value
                        },
                        dataType: "json",
                        async: false,
                    } as RequestServerParams;
                    o.successFunction = function (data) {
                        const popup = $('#popup').dxPopup({
                            width: 650,
                            height: 600,
                            showTitle: true,
                            title: this.name,
                            visible: false,
                            dragEnabled: false,
                            hideOnOutsideClick: false,
                            contentTemplate: () => {
                                let content = $(data.view);
                                return content;
                            },
                            onShown: function (e) {
                                if (typeof customSetupSystemSettingsRow === "function") {
                                    customSetupSystemSettingsRow();
                                }
                            },
                            toolbarItems: [
                                {
                                    widget: 'dxButton',
                                    toolbar: 'bottom',
                                    location: 'after',
                                    options: {
                                        text: 'Confirm',
                                        onClick: function () {
                                            if (typeof customSaveSystemSettingsRow === "function") {
                                                let data = customSaveSystemSettingsRow(oldValue);
                                                if (data.valid) {
                                                    e.setValue(data.data);
                                                    popup.hide();
                                                }
                                            }
                                            else {
                                                alert("'customSaveSystemSettingsRow' not implemented")
                                            }
                                        }.bind(this)
                                    }
                                },
                                {
                                    widget: 'dxButton',
                                    toolbar: 'bottom',
                                    location: 'after',
                                    options: {
                                        text: 'Close',
                                        onClick() {
                                            popup.hide();
                                        }
                                    }
                                }
                            ]
                        }).dxPopup('instance');
                        popup.show();
                    }.bind(this);
                    o.failureFunction = function (textStatus, errorThrown, errorItem: IError) {
                        errorItem.userMessage = "Failed to get system setting";
                        irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, errorThrown);
                    };

                    irGlobal.requestServer(o);

                }.bind(e.row.data);
                break;
            default:
                break;
        }


    };

    enum SystemSettingEditorTypeEnum {
        Dropdown = 0,
        Numeric = 1,
        Textbox = 2,
        Switch = 3,
        ColorPicker = 4,
        Date = 5,
        Custom = 6
    }

    enum SystemSettingRowTypeEnum {
        Numeric = 0,
        Text = 1,
        Boolean = 2,
        Date = 3,
        JSON = 4,
    }
}